import React from 'react';
import { Link } from 'react-router-dom';
import Dropdowns from '../Filters/Dropdowns/Dropdowns';
import CheckboxAndInput from '../CheckboxAndInput/CheckboxAndInput';

export default (props) => (
	<div>
		<form onSubmit={props.handleSubmit}>
			<div className="nameDesc">
				<div className="inputGroup">
					<p>Name: </p>
					<input
						placeholder={props.rooms ? props.rooms.name : ''}
						type="text"
						name="name"
						value={props.state.name}
						onChange={props.handleInputChange} />
				</div>
				<div className="inputGroup">
					<p>Description: </p>
					<input
						placeholder={props.rooms ? props.rooms.description : ""}
						type="text"
						name="description"
						value={props.state.description || ''}
						onChange={props.handleInputChange} />
				</div>
			</div>

			<div className="reservable">
				<p>Reservable: </p>
				<div className="inputGroup">
					<input
						type="checkbox"
						name="isReservable"
						value={props.state.isReservable || false}
						onChange={props.handleInputChange} checked={props.state.isReservable}
					/>
				</div>
				<br />
				<p className="isActive">Is Active: </p>
				<div className="inputGroup">
					<input
						type="checkbox"
						name="isActive"
						value={props.rooms ? props.rooms.isActive : true}
						onChange={props.handleInputChange} checked={props.state.isActive}
					/>
				</div>
			</div>

			<div className="dropdowns">
				<Dropdowns
					name="buildingId"
					placeholderName="Building"
					form={true} type="select"
					filterClassName="{item.filterClass}"
					defaultValue={props.state.buildingId}
					items={props.buildings}
					onChange={props.handleInputChange}
				/>
				<Dropdowns
					name="floorId"
					placeholderName="Floor"
					form={true}
					type="select"
					filterClassName="{item.filterClass}"
					defaultValue={props.state.floorId}
					items={props.floors}
					onChange={props.handleInputChange}
				/>
			</div>

			<hr />

			<div className="roomTypeAndRes">
				<div className="roomTypeGroup">
					<p>Room Type:</p>
					<div className="dnvHolder">
						<Dropdowns
							placeholderName="Room Type"
							name="roomTypeId"
							form={true}
							type="select"
							filterClassName="{item.filterClass}"
							defaultValue={props.state.roomTypeId}
							items={props.roomTypes}
							onChange={props.handleInputChange}
						/>
					</div>
				</div>

				<div className="fixedResource">
					<p>Fixed Resource(s):</p>
					<div className="dnvHolder">
						{
						  props.rooms ? 
							props.rooms.assets && props.rooms.assets.filter(i => i.isFixed === true).length > 0  ?
								props.rooms.assets.filter(i => i.isFixed === true).map((item, i) => {
									return (
										<p className="fixedAssetItem" key={i}>{item.name}</p>										
									);
								})
								:
					    <p className="fixedAssetItem">No Fixed Resources</p> : <p className="fixedAssetItem">No Fixed Resources</p>
						}
					</div>
				</div>
			
			</div>

			<div className="roomDetailGroup">
				<p>Detail Types:</p>
				<div className="rdMultiSelect">
					<div className="headers">
						<p className="detail">Detail</p>
					</div>
					<div className="dnvHolder">
						<CheckboxAndInput
							keyName="roomDetailTypeId"
							items={props.roomDetailTypes}
							isEdit={props.isEdit}
							state={props.state.roomDetails}
							disableNotEditable={true}
							name="roomDetails"
							onChange={props.handleCheckboxAndInputChange}
						/>
					</div>
				</div>
			</div>

			<div className="formControls">
				<Link className="addCancel" to="/rooms">Cancel</Link>
				<input className="addSubmit" type="submit" value={props.addLabel ? "Add Room" : "Edit Room"} />
			</div>
		</form>
	</div>
);



// WEBPACK FOOTER //
// ./src/Components/Pages/RoomsEditAddComponent.js